
import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Tabs, Spin, Alert, Modal, Tooltip, Button } from 'antd';
import { getcomplitedBookingFlights, getCancelledBookingFlights, getUpcomingBookingFlights, getBookingPdf } from '../services/auth/authServices';
import moment from 'moment';
import TravllerBookingDetails from './TravllerBookingDetails';
import { FaDownload, FaEye } from 'react-icons/fa';

const FlightBookingHistory = () => {
    const [activeKey, setActiveKey] = useState('1');
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [cancelledFlights, setCancelledFlights] = useState([]);
    const [booking_id, setBooking_id] = useState(null)

    const fetchData = async (type) => {
        setLoading(true);
        setError(null);

        try {
            let data;
            if (type === '1') {
                data = await getUpcomingBookingFlights();
            } else if (type === '2') {
                data = await getCancelledBookingFlights();
            } else if (type === '3') {
                data = await getcomplitedBookingFlights();
            }
            setDataSource(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(activeKey);
    }, [activeKey]);

    const onChangeTabs = (key) => {
        setActiveKey(key);
    };
    const handleAction = (record) => {
        setBooking_id(record)
        setIsModalVisible(true)
    }

    const generatePdf = async (booking_id) => {
        try {
            const response = await getBookingPdf(booking_id);
            setLoading(false)
            const file = new Blob([response], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = 'ticket.pdf';
            link.click();
            URL.revokeObjectURL(link.href);

        } catch (error) {
            setLoading(false)
            console.error('Error downloading the PDF:', error);
        }
    }

    const columns = [
        {
            title: 'Booking ID',
            dataIndex: 'bookingID',
            key: 'bookingID',
        },
        {
            title: 'Traveller',
            dataIndex: 'guestName',
            key: 'guestName',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Booking Date',
            dataIndex: 'booking_date',
            key: 'booking_date',
        },
        {
            title: 'Payment Status',
            dataIndex: 'paymentStatus',
            key: 'paymentStatus',
        },
        {
            title: 'Booking Status',
            dataIndex: 'bookingStatus',
            key: 'bookingStatus',
        },
        {
            title: 'Route (Departure - Arrival)',
            dataIndex: 'route',
            key: 'route',
        },
        {
            title: 'Flight Details',
            dataIndex: 'flightDetails',
            key: 'flightDetails',
        },

        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '10px' }}>
                    {/* View Button */}
                    <Tooltip title="View Details">
                        <Button
                            type="primary"
                            icon={<FaEye />}
                            onClick={() => handleAction(record?.id)}
                             aria-label="eye"
                        >

                        </Button>
                    </Tooltip>

                    {/* Download Button */}
                    <Tooltip title="Download Ticket">
                        <Button
                            type="primary"
                            icon={<FaDownload />}
                            onClick={() => generatePdf(record?.id)}
                             aria-label="download"
                        >

                        </Button>
                    </Tooltip>
                </div>
            ),
        },

    ];


    return (
        <>
            <section className='my-booking mb-5'>
                <div className='container'>
                    <Row gutter={16}>
                        <Col md={24}>
                            <Tabs
                                className='mainTabs'
                                defaultActiveKey="1"
                                onChange={onChangeTabs}
                                items={[
                                    {
                                        key: '1',
                                        label: 'Upcoming Bookings',
                                    },
                                    {
                                        key: '2',
                                        label: 'Cancelled Bookings',
                                    },
                                    {
                                        key: '3',
                                        label: 'Completed Bookings',
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                    <Row gutter={16} className="">
                        <Col md={24} >
                            {loading ? (
                                <Spin style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60vh"
                                }} />
                            ) : error ? (
                                <Alert message="Error" description={error} type="error" showIcon />
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={dataSource?.data?.map((item, index) => {
                                        const travelInfos = item?.travelInfos?.[0];
                                        const departureCity = travelInfos?.departure_city || 'N/A';
                                        const arrivalCity = travelInfos?.arrival_city || 'N/A';
                                        return {
                                            key: index,
                                            id: item?.id,
                                            bookingID: item?.smt_booking_id || 'N/A',
                                            guestName: item?.passengers?.[0]?.first_name || 'Unknown',
                                            amount: Math.round(item?.total_amount) || '0.00',
                                            booking_date: moment(item?.booking_date).format("DD-MM-YYYY") || 'N/A',
                                            paymentStatus: item?.payment_status === 'CHARGED' ? "SUCCESS" : item?.payment_status || 'Pending',
                                            bookingStatus: item?.booking_status || 'Not Confirmed',
                                            route: `${departureCity} - ${arrivalCity}`,
                                            flightDetails: `${travelInfos?.airline} (${travelInfos?.flightNumber})`,
                                        };
                                    })}
                                    pagination={{ pageSize: 10 }}
                                />
                            )}
                        </Col>
                    </Row>
                </div>
            </section>


            <Modal
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={false}
                width={1020}
                centered
            >
                <TravllerBookingDetails booking_id={booking_id} />
            </Modal>
        </>
    );
};

export default FlightBookingHistory;
